<div
  style="position: relative"
  [ngClass]="{
    'has-error': (isError ?? !formReference.valid) && formReference.touched
  }"
>
  <ng-content></ng-content>

  <app-error-display
    [control]="formReference"
    [customMessage]="customMessage"
    [showCharacterCount]="showCharacterCount"
    [maxLength]="totalLength"
    [currentLength]="formReference?.value?.length || 0"
  >
  </app-error-display>
</div>
